<template>
  <div v-if="assignment" class="">
    <template v-if="assignment">
      <v-list>
        <!-- Block Information -->
        <v-list-item class="assignment-item mb-2">
          <v-list-item-icon>
            <v-avatar color="primary" size="40">
              <v-icon dark>mdi-office-building</v-icon>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle class="text-caption">Block</v-list-item-subtitle>
            <v-list-item-title class="text-h6 font-weight-medium">
              {{ assignment.roomSpace?.room?.floor?.block?.name || 'Not Assigned' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <!-- Floor Information -->
        <v-list-item class="assignment-item my-2">
          <v-list-item-icon>
            <v-avatar color="info" size="40">
              <v-icon dark>mdi-elevator</v-icon>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle class="text-caption">Floor</v-list-item-subtitle>
            <v-list-item-title class="text-h6 font-weight-medium">
              {{ assignment.roomSpace?.room?.floor?.name || 'Not Assigned' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <!-- Room Information -->
        <v-list-item class="assignment-item my-2">
          <v-list-item-icon>
            <v-avatar color="success" size="40">
              <v-icon dark>mdi-door</v-icon>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle class="text-caption">Room</v-list-item-subtitle>
            <v-list-item-title class="text-h6 font-weight-medium">
              {{ assignment.roomSpace?.room?.name || 'Not Assigned' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <!-- Space Information -->
        <v-list-item class="assignment-item mt-2">
          <v-list-item-icon>
            <v-avatar color="warning" size="40">
              <v-icon dark>mdi-bed</v-icon>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle class="text-caption">Space</v-list-item-subtitle>
            <v-list-item-title class="text-h6 font-weight-medium">
              {{ assignment.roomSpace?.name || 'Not Assigned' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Quick Actions -->
              <v-card-actions class="mt-4">
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    class="px-4"
                    @click="downloadLetter"
                    v-if="assignment.approved && assignment.accepted && (assignment.maintenancePaid || (config && !config?.requiresMaintenanceFee))"
                >
                  <v-icon left>mdi-download-multiple</v-icon>
                  Allocation Letter
                </v-btn>
<!--                <v-btn-->
<!--                    text-->
<!--                    color="secondary"-->
<!--                    class="px-4"-->
<!--                    @click="$emit('request-change')"-->
<!--                >-->
<!--                  <v-icon left>mdi-swap-horizontal</v-icon>-->
<!--                  Request Change-->
<!--                </v-btn>-->
              </v-card-actions>
      <!-- Status Indicator -->

      <v-alert
          type="success"
          dense
          text
          class="mt-4"
      >
        Your hostel space has been successfully assigned.
        <v-chip
            class="status-chip"
            :color="assignment.approved ? 'success' : (assignment.accepted ? 'warning' : 'error')"
            small
            label
        >
          {{ assignment.approved ? 'Approved' : (assignment.accepted ? 'Accepted, awaiting approval' : 'Acceptance pending...') }}
        </v-chip>
      </v-alert>
    </template>
    <v-alert
        v-else
        type="warning"
        dense
        text
    >
      Waiting for hostel assignment
    </v-alert>
    <loading-dialog :show="loading"></loading-dialog>
  </div>
</template>

<script>
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import LoadingDialog from "@ui/components/LoadingDialog.vue";

export default {
  name: "StudentSpaceInformation",
  components: {LoadingDialog},
  props: ['assignment', "config"],
  emits: ['download-letter'],
  data: () => ({
    loading: false
  }),
  methods: {
    downloadLetter(){
      if(!this.assignment)
        return

      this.loading = true
      Api.hostel.studentAllocationReport(this.assignment.id).then(res => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        let fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'allocationLetter.pdf');
        document.body.appendChild(fileLink);

        fileLink.click();
        fileLink.remove();
      }).catch(err => ErrorResolver.process(this, err))
          .finally(() => this.loading = false)
    }
  }
}
</script>


<style scoped>

</style>
